import { END_POINTS } from "../constants/url";
import { CommonBody, FaqRes, CMS, GetFaqResponse } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  code: number;
  status?: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  code: number;
  status?: number;
  message?: string;
  data?: any;
}

interface GetCmsResponse {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  aboutUs: string;
  dialCode: string;
}

export interface GetSettingResponse {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponse & { data: GetCmsResponse }, {}>({
      query: () => ({
        url: END_POINTS.getCms,
        method: "GET",
      }),
    }),
    updateCms: builder.mutation<
      CommonResponseType & { data: CMS },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.updateCms}`,
        method: "POST",
        body,
      }),
    }),
    getFAQ: builder.query<
      CommonResponseType & { data: GetFaqResponse },
      {
        search: string;
        start: number;
        length: number;
      }
    >({
      query: ({ search, start, length }) => ({
        url: `${END_POINTS.getFaq}?start=${start}&length=${length}&search=${search}`,
        method: "GET",
      }),
    }),
    addFAQ: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addFaq,
        method: "POST",
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody; id: any }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFaq}/${id}/`,
        method: "PUT",
        body,
      }),
    }),
    deleteFaq: builder.mutation<
      CommonResponseType,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFaq}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useLazyGetFAQQuery,
  useAddFAQMutation,
  useUpdateFaqMutation,
  useDeleteFaqMutation,
} = faqApi;
